import type { AxiosInstance } from 'axios';
import type { LocalizationLanguage } from '@gov-nx/core/app/localization/languages';
import type { PageCode } from '@gov-nx/module/page/definitions/codes';
import type { CmsPageResponse } from './types';

export interface CmsPageQueryParams {
	code: PageCode;
	locale: LocalizationLanguage;
	cmsKeyCache: string;
}

export const cmsPageQuery = async (
	axiosCmsInstance: AxiosInstance,
	{ code, locale, cmsKeyCache }: CmsPageQueryParams
) => {
	const response = await axiosCmsInstance.get<CmsPageResponse>(
		`/pages/${code}-${locale}.json?v=${cmsKeyCache}`
	);
	return response.data.data;
};
